import GridBackground from './components/GridBackground';
import ProductShowcase from './components/ProductShowcase';
import Headline from './components/Headline';
import TopNav from './components/TopNav';
import Subtitle from './components/Subtitle';
import BottomInfoBar from './components/BottomInfoBar';
import AnchorLabels from './components/AnchorLabels';
import ChapterTwoStage from './components/ChapterTwoStage';
import SoundArchitecture from './components/SoundArchitecture';
import Colorways from './components/Colorways';
import StudioSection from './components/StudioSection';
import ReserveSection from './components/ReserveSection';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  // ⚠️ The sticky hero block below (500vh + inner sticky viewport) is
  // locked and must NOT be modified — it is the completed scroll-driven
  // Chapter 001/002 experience. New content is appended below it.
  //
  // Timeline (progress = window.scrollY / (docHeight - viewport)):
  //   0.00 – 0.03  intro pose
  //   0.03 – 0.16  chalk model + slow scroll rotation
  //   0.16 – 0.36  color reveal (model is still)
  //   0.36 – 0.65  labels + orbiting cards
  //   0.65 – 1.00  Chapter 002: model shrinks + moves left, right-side story
  return (
    <div className="relative w-full" style={{ backgroundColor: '#141B2A' }}>
      {/* ── Locked sticky hero (Chapter 001 + 002) ── */}
      <div
        className="relative w-full"
        style={{ backgroundColor: '#141B2A', height: '500vh' }}
      >
        <div
          className="sticky top-0 w-full h-screen overflow-hidden"
          style={{ backgroundColor: '#141B2A' }}
        >
          <GridBackground />
          <ChapterTwoStage />
          <ProductShowcase />
          <Headline />
          <Subtitle />
          <AnchorLabels />
          <TopNav />
          <BottomInfoBar />
        </div>
      </div>

      {/* ── Story continues: new sections appended below ── */}
      <SoundArchitecture />
      <Colorways />
      <StudioSection />
      <ReserveSection />
      <SiteFooter />
    </div>
  );
}